import { Component } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-electronic-disclosure-modal',
	templateUrl: './electronic-disclosure-modal.component.html',
	styleUrls: ['./electronic-disclosure-modal.component.scss'],
})
export class ElectronicDisclosureModalComponent {
	constructor() { }
}
